import script from "./AdminNavigation.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminNavigation.vue?vue&type=script&setup=true&lang=js"

import "./AdminNavigation.vue?vue&type=style&index=0&id=0034a87a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0034a87a"]])

export default __exports__